import { getConfigAmbienteDominio } from '../services/authentication/auth';

/**
 * Allowlist das origens autorizadas a enviar mensagens via postMessage para o shell.
 *
 * As URLs dos micro-frontends usam o placeholder TENANT (ex.: http://hub.TENANT),
 * resolvido em runtime pelo dominio do tenant corrente, da mesma forma que
 * montaUrlExterna faz em services/authentication/auth.js.
 *
 * Modo log-only: enquanto MODO_BLOQUEIO for false, mensagens de origem desconhecida
 * sao apenas registradas no console, sem serem descartadas. Isso permite mapear
 * origens legitimas ainda nao previstas antes de ativar o bloqueio.
 */

const MODO_BLOQUEIO = process.env.REACT_APP_BLOQUEAR_ORIGEM_POSTMESSAGE === 'true';

const ENVS_MICRO_FRONTENDS = [
  'REACT_APP_LINK_HUB_UI',
  'REACT_APP_ISEVEN_BASE_URL',
  'REACT_APP_MODULUS_BASE_URL',
  'REACT_APP_LINK_PLATAFORMA_DIGITAL'
];

const origensJaAvisadas = new Set();

const extraiOrigem = url => {
  if (!url) {
    return null;
  }

  try {
    return new URL(url).origin;
  } catch (er) {
    return null;
  }
};

export const listaOrigensConfiaveis = () => {
  const dominio = getConfigAmbienteDominio();

  const origens = ENVS_MICRO_FRONTENDS.map(nomeEnv => {
    const valor = process.env[nomeEnv];

    if (!valor) {
      return null;
    }

    return extraiOrigem(dominio ? valor.replace('TENANT', dominio) : valor);
  }).filter(Boolean);

  return [...new Set([...origens, window.location.origin])];
};

/**
 * Indica se a origem de um evento de postMessage e confiavel.
 *
 * Em modo log-only sempre retorna true, registrando o aviso uma unica vez
 * por origem para nao poluir o console.
 */
export const origemConfiavel = origem => {
  if (listaOrigensConfiaveis().includes(origem)) {
    return true;
  }

  if (!origensJaAvisadas.has(origem)) {
    origensJaAvisadas.add(origem);
    console.warn(
      `[postMessage] Origem nao reconhecida: ${origem || '(vazia)'}.`,
      MODO_BLOQUEIO ? 'Mensagem descartada.' : 'Mensagem aceita (modo log-only).',
      'Origens confiaveis:',
      listaOrigensConfiaveis()
    );
  }

  return !MODO_BLOQUEIO;
};
